import { render, staticRenderFns } from "./ModusignList.vue?vue&type=template&id=819980c2&scoped=true&"
import script from "./ModusignList.vue?vue&type=script&lang=js&"
export * from "./ModusignList.vue?vue&type=script&lang=js&"
import style0 from "./ModusignList.vue?vue&type=style&index=0&id=819980c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819980c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
